<template>
  <el-select
    v-model="defaultLang"
    size="large"
    class="w-44"
    @change="switchLanguage"
    data-cy="switchLang"
    filterable
    :no-match-text="$t('message.noData')"
  >
    <el-option v-for="lang in languages" :key="lang.key" :label="lang.label" :value="lang.key" />
  </el-select>
</template>
<script>
import { defineComponent, ref } from 'vue'
import { setI18nLanguage } from 'locales'

export default defineComponent({
  name: 'LanguageSwitcher',
  setup() {
    const defaultLang = ref(localStorage.getItem('lang') || 'en')
    const languages = ref([
      {
        key: 'en',
        label: 'English',
      },
      {
        key: 'ja',
        label: '日本語',
      },
      {
        key: 'zh',
        label: '繁體中文',
      },
    ])

    const switchLanguage = (nLocale) => {
      setI18nLanguage(nLocale)
    }

    return {
      languages,
      defaultLang,
      switchLanguage,
    }
  },
})
</script>
